module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hello":"Hello i18n in SFC English!"},"nl":{"hello":"Hello i18n in SFC Nederlands!"}}')
  delete Component.options._Ctor
}
